import type {
  CouponActivityRecord,
  ServiceOrganizationCouponActivityListApiData,
  ServiceOrganizationCouponActivityListApiResponses,
  ServiceOrganizationCouponCreateApiData,
  ServiceOrganizationCouponCreateApiResponses,
  ServiceOrganizationCouponDeleteApiData,
  ServiceOrganizationCouponDeleteApiResponses,
  ServiceOrganizationCouponGetApiData,
  ServiceOrganizationCouponGetApiResponses,
  ServiceOrganizationCouponListApiData,
  ServiceOrganizationCouponListApiResponses,
  ServiceOrganizationCouponPatchApiData,
  ServiceOrganizationCouponPatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export type { CouponActivityRecord };

export const getServiceOrganizationCouponUrls = {
  getPaginatedServiceOrganizationCoupons: dataEndpoint<
    ServiceOrganizationCouponListApiData,
    ServiceOrganizationCouponListApiResponses
  >({
    getUrl: ({ serviceOrganizationId, ...queryParams }) =>
      apiUrl(`service-organizations/${serviceOrganizationId}/coupons/`, queryParams)
  }),
  getServiceOrganizationCoupon: dataEndpoint<
    ServiceOrganizationCouponGetApiData,
    ServiceOrganizationCouponGetApiResponses
  >({
    getUrl: ({ serviceOrganizationId, couponId }) =>
      apiUrl(`service-organizations/${serviceOrganizationId}/coupons/${couponId}/`)
  }),
  getPaginatedServiceOrganizationCouponActivities: dataEndpoint<
    ServiceOrganizationCouponActivityListApiData,
    ServiceOrganizationCouponActivityListApiResponses
  >({
    getUrl: ({ serviceOrganizationId, couponId, ...queryParams }) =>
      apiUrl(`service-organizations/${serviceOrganizationId}/coupons/${couponId}/activities/`, queryParams)
  }),
  postServiceOrganizationCoupon: responseEndpoint<
    ServiceOrganizationCouponCreateApiData,
    ServiceOrganizationCouponCreateApiResponses
  >({
    getUrl: ({ serviceOrganizationId }) => apiUrl(`service-organizations/${serviceOrganizationId}/coupons/`),
    getBody: (data) => data
  }),
  deleteServiceOrganizationCoupon: dataEndpoint<
    ServiceOrganizationCouponDeleteApiData,
    ServiceOrganizationCouponDeleteApiResponses
  >({
    getUrl: ({ serviceOrganizationId, couponId }) =>
      apiUrl(`service-organizations/${serviceOrganizationId}/coupons/${couponId}/`)
  }),
  patchServiceOrganizationCoupon: responseEndpoint<
    ServiceOrganizationCouponPatchApiData,
    ServiceOrganizationCouponPatchApiResponses
  >({
    getUrl: ({ serviceOrganizationId, couponId }) =>
      apiUrl(`service-organizations/${serviceOrganizationId}/coupons/${couponId}/`),
    getBody: (data) => data
  })
};
